import { Icon, IconProps } from './Icon';

export type RouteProps = IconProps;

export const Route = (props: RouteProps) => (
  <Icon width="16px" height="16px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M7.667 3.333h.29c2.03 0 3.047 0 3.432.365.333.315.481.78.391 1.23-.104.52-.933 1.107-2.592 2.28l-2.71 1.917c-1.658 1.173-2.487 1.76-2.591 2.28-.09.45.057.915.39 1.23C4.664 13 5.68 13 7.71 13h.623m-3-9.667a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm9.334 9.334a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
